import { showErrorMessage } from 'helpers';
import {
  MultiTaskUpdateModal,
  UpdatedTaskEntities,
} from 'pages/Workshop/Transactions/components/MultiTaskUpdateModal';
import { useDispatch } from 'react-redux';
import { deleteMultipleTasksEffect, updateMultipleTasksEffect } from 'store/effects/taskAggregate';

export const TasksUpdateModal = (props) => {
  const dispatch = useDispatch();

  const {
    fullAccess,
    isAggregatePage,
    selectedTaskIds,
    showTaskUpdateModal,
    setShowTaskUpdateModal,
    setShowSelection,
  } = props;

  const handleUpdateTasks = async (
    updatedTaskEntities: UpdatedTaskEntities,
    setLoading: (loading: boolean) => void,
  ) => {
    setLoading(true);
    const tasks = selectedTaskIds?.map((taskId) => ({ Id: taskId, ...updatedTaskEntities }));
    dispatch(
      updateMultipleTasksEffect({ tasks }, (err) => {
        setLoading(false);
        if (err) {
          showErrorMessage(err);
        }
        setShowTaskUpdateModal(false);
        setShowSelection(false);
      }),
    );
  };

  const handleDeleteTasks = async (
    setLoading: (loading: boolean) => void,
    setShowModal: (open: boolean) => void,
  ) => {
    setLoading(true);
    dispatch(
      deleteMultipleTasksEffect(selectedTaskIds, (err) => {
        setLoading(false);
        if (err) {
          showErrorMessage(err);
        } else {
          setShowModal(false);
          setShowTaskUpdateModal(false);
          setShowSelection(false);
        }
      }),
    );
  };
  return (
    <MultiTaskUpdateModal
      fullAccess={fullAccess}
      showTaskUpdateModal={showTaskUpdateModal}
      isAggregatePage={isAggregatePage}
      setShowTaskUpdateModal={setShowTaskUpdateModal}
      handleUpdateTasks={handleUpdateTasks}
      handleDeleteTasks={handleDeleteTasks}
    />
  );
};
